import { useCallback } from "react";

import {
  useFormatBoolean,
  useFormatCurrency,
  useFormatDate,
  useFormatFloat,
  useFormatInteger,
  useFormatPercentage,
} from "src/internationalization";
import { TypedValue } from "src/types/typedValue";

export const useFormatTypedValue = () => {
  const formatDate = useFormatDate();
  const formatCurrency = useFormatCurrency();
  const formatPercentage = useFormatPercentage();
  const formatFloat = useFormatFloat();
  const formatInteger = useFormatInteger();
  const formatBoolean = useFormatBoolean();

  const formatTypedValue = useCallback(
    (value: TypedValue) => {
      switch (value.type) {
        case "date":
          return formatDate(value.value, {
            timeStyle: "short",
            dateStyle: "medium",
          });
        case "amount":
          return formatCurrency(value.value);
        case "percentage":
          return formatPercentage(value.value);
        case "float":
          return formatFloat(value.value);
        case "boolean":
          return formatBoolean(value.value);
        case "integer":
          return formatInteger(value.value);
        case "dateTime":
          return formatDate(value.value, {
            timeStyle: "short",
            dateStyle: "medium",
          });
        default:
          return value.value;
      }
    },
    [formatBoolean, formatCurrency, formatDate, formatFloat, formatInteger, formatPercentage]
  );

  return formatTypedValue;
};
